<template>
  <div class="main-body">
    <div class="header">商家配餐计划</div>
    <div class="out">

      <div class="search2">

        <div style="float:right">

          <el-select v-model="businessCode" placeholder="请选择商家">
            <el-option
                v-for="item in arr_business"
                :key="item.businessCode"
                :label="item.name"
                :value="item.businessCode">
            </el-option>
          </el-select>

          <el-date-picker size="mini"
                          ref="picker"
                          v-model="datetimerangeValue"
                          type="daterange"
                          :clearable='false'
                          value-format="yyyy-MM-dd"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          style="width:230px;margin-left:10px">
          </el-date-picker>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th"
                border default-expand-all>

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="早餐：" v-if="props.row.dishesPlanMorningDTO">
                <el-tag v-for="(value,i) in props.row.dishesPlanMorningDTO.listDishesPlanMorningItem" :key="i" style="margin-right: 5px;">{{value.dishesName}}</el-tag>
              </el-form-item>
              <el-form-item label="午餐：" v-if="props.row.dishesPlanNoonDTO">
                <el-tag v-for="(value,i) in props.row.dishesPlanNoonDTO.listDishesPlanNoonItem" :key="i" style="margin-right: 5px;" >{{value.dishesName}}</el-tag>
              </el-form-item>
              <el-form-item label="晚餐：" v-if="props.row.dishesPlanNightDTO">
                <el-tag v-for="(value,i) in props.row.dishesPlanNightDTO.listDishesPlanNightItem" :key="i" style="margin-right: 5px;" >{{value.dishesName}}</el-tag>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="time" :formatter="getTime" label="日期"></el-table-column>
        <el-table-column prop="day" label="星期"></el-table-column>

        <el-table-column prop="Status" :formatter="statusTitle" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">正常</span>
            <span v-if="scope.row.status == 1">禁用</span>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode,getGovernmentCode} from "@/utils/auth";

export default {
  name: "Page",
  data(){
    return{
      loading:false,

      datetimerangeValue:'',

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_business:[],
      businessCode: '',

    }
  },
  components:{

  },
  created(){
    this.init();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{
    init(){

      const start= new Date();
      const end=new Date(start.getTime() + 1000 * 60 * 60 * 24 * 30);
      this.datetimerangeValue=[start, end];

      this.getBusiness();

    },

    getTime(row){
      return timefilters(row.time).slice(0,10)
    },


    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/GovList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          governmentCode: getGovernmentCode(),
          businessType:3,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_business = response.data.data;
          if(this.arr_business.length>0){
            this.businessCode = this.arr_business[0].businessCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"DishesPlan/GovBusinessPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          businessCode:this.businessCode,
          startTime:this.datetimerangeValue[0],
          endTime:this.datetimerangeValue[1],
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then( (response)=> {

        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },



    formatTime:function (row, column, cellValue) {
      return timefilters(cellValue);
    },

    statusTitle(row){
      if(row.status == 0){
        return "正常";
      }
      if(row.status == 1){
        return "禁用";
      }
      return "其它";
    },


  }
}
</script>

<style>
.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  /* width: 100%; */
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
<style lang="scss" scoped>
/deep/ .el-table__body tr.current-row>td {
  background-color: #409EFF;
  color:#fff;
}

</style>
